import { render } from "./ControlsLeftComponent.vue?vue&type=template&id=63f9996d&scoped=true&ts=true"
import script from "./ControlsLeftComponent.vue?vue&type=script&lang=ts"
export * from "./ControlsLeftComponent.vue?vue&type=script&lang=ts"

import "./ControlsLeftComponent.vue?vue&type=style&index=0&id=63f9996d&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f9996d"]])

export default __exports__